import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = {
  key: 2,
  class: "mt-6 p-4 bg-gray-100 rounded text-gray-900"
}
const _hoisted_6 = { class: "inline-block" }

import { computed, defineAsyncComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { FormItem } from '@/models';
import { IOption } from '@/lib';
import BaseIcon from '@/lib/components/Icon/BaseIcon.vue';
import dayjs from 'dayjs';
import { localisedMask } from '@/helpers/date.helper';
import { i18n } from '@/i18n/i18n';
import { getAnswer } from '@/helpers/smart-form.helper';
import { useSmartFormStore } from '@/stores/smartForm.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmartFormSummaryItem',
  props: {
  item: {
    type: Object as PropType<FormItem>,
    required: true
  },
  patientId: {
    type: String,
    default: null
  },
  participantId: {
    type: String,
    default: null
  },
  formSubmissionId: {
    type: String,
    required: true
  },
  level: {
    type: Number,
    default: 0
  },
  locale: {
    type: String,
    default: i18n.global.locale.value
  }
},
  setup(__props) {

const props = __props;

const { t } = useI18n();



const smartForm = useSmartFormStore();

const CheckListItem = defineAsyncComponent(() => import('@/lib/components/Checkbox/CheckListItem.vue'));
const SmartFormRepeater = defineAsyncComponent(() => import('@/lib/components/SmartForm/SmartFormRepeater.vue'));

const conditionsMet = computed(() => smartForm.getItemConditionsMet(props.formSubmissionId, props.item.conditions));
const itemTypeHasValue = computed(() => !['group', 'component', 'repeater', 'spacer', 'list-item', 'label'].includes(props.item.type));
const answer = computed(() => getAnswer(smartForm, props.formSubmissionId, props.item, true));
const formattedAnswer = computed(() => {
  if (props.item.type === 'slider' && props.item.props) {
    return props.item.props.options[answer.value];
  }

  if (Array.isArray(answer.value)) {
    if (props.item.type === 'checkbox' && props.item.props) {
      return answer.value
        .map((answer) => {
          const options = (props.item.props as { [key: string]: any }).options;
          const option = options && options.find((opt: IOption) => opt.value === answer);
          return option ? option.label : null;
        })
        .filter(Boolean)
        .join(', ');
    } else if (props.item.type === 'file') {
      return t('platform.common.file-upload.count-message', [answer.value.length], { locale: props.locale });
    }
    return answer.value.join(', ');
  }

  if (typeof answer.value === 'boolean') {
    return answer.value ? t('platform.common.yes', [], { locale: props.locale }) : t('platform.common.no', [], { locale: props.locale });
  }

  if (props.item.props?.options && Array.isArray(props.item.props.options) &&
    !props.item.props.options.find((option) => !option.label || !option.value)) {
    const option = props.item.props.options.find((opt: IOption) => opt.value === answer.value);
    if (option) {
      return option.label;
    }
  }

  if (props.item.type === 'date' && dayjs(answer.value).isValid()) {
    return dayjs(answer.value).format(localisedMask(props.locale, props.item.props?.mode));
  }

  return answer.value;
});

const componentType = computed(() => {

  if (props.item.component) {
    return defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: "component-[request]" */
          `@/${props.item.component}.vue`
        )
    );
  }

  if (props.item.type === 'repeater') {
    return SmartFormRepeater;
  }

  if (props.item.type === 'list-item') {
    return CheckListItem;

  }

  return null;

});


return (_ctx: any,_cache: any) => {
  const _component_SmartFormSummaryItem = _resolveComponent("SmartFormSummaryItem", true)!

  return (_unref(conditionsMet) && __props.item.type !== 'hidden')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.item.label || (__props.item.props?.label && _unref(itemTypeHasValue)) || __props.item.icon || __props.item.type === 'spacer')
          ? (_openBlock(), _createBlock(_resolveDynamicComponent('h' + (__props.level + 3)), {
              key: 0,
              class: "flex items-center font-semibold text-gray-900"
            }, {
              default: _withCtx(() => [
                (__props.item.icon)
                  ? (_openBlock(), _createBlock(BaseIcon, {
                      key: 0,
                      name: __props.item.icon,
                      height: "24px",
                      color: "white",
                      class: "mr-3"
                    }, null, 8, ["name"]))
                  : _createCommentVNode("", true),
                (__props.item.label)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.item.label), 1))
                  : _createCommentVNode("", true),
                (__props.item.props?.label)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.item.props.label), 1))
                  : _createCommentVNode("", true),
                (__props.item.type === 'spacer')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "   "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (__props.item.type === 'component' || __props.item.type === 'repeater' || __props.item.type === 'list-item')
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(componentType)), _mergeProps({
              key: 1,
              id: __props.item.id,
              readonly: "",
              item: __props.item,
              model: _unref(answer),
              value: _unref(answer),
              "model-value": _unref(answer)
            }, __props.item.props, {
              "patient-id": __props.patientId,
              "participant-id": __props.participantId,
              "form-submission-id": __props.formSubmissionId
            }), null, 16, ["id", "item", "model", "value", "model-value", "patient-id", "participant-id", "form-submission-id"]))
          : _createCommentVNode("", true),
        (_unref(itemTypeHasValue))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(formattedAnswer)), 1)
            ]))
          : _createCommentVNode("", true),
        (__props.item.items && __props.item.type !== 'repeater')
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass([__props.item.layout === 'grid' ? 'grid gap-4 grid-cols-' + __props.item.cols || 1 : 'mt-6'])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.items, (subItem) => {
                return (_openBlock(), _createBlock(_component_SmartFormSummaryItem, {
                  key: subItem.id,
                  item: subItem,
                  "patient-id": __props.patientId,
                  "participant-id": __props.participantId,
                  "form-submission-id": __props.formSubmissionId,
                  locale: __props.locale,
                  level: __props.level + 1
                }, null, 8, ["item", "patient-id", "participant-id", "form-submission-id", "locale", "level"]))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})